
// src/components/BranchStockDialog.jsx
import React, { useMemo, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';

/**
 * Props:
 * - open: boolean
 * - onClose: function
 * - product: object (should include branch_stock: [{id_branch, name_branch, qty}])
 * - onConfirm: function(selections) -> optional callback receiving array of {id_branch, requestedQty}
 */
const BranchStockDialog = ({ open, onClose, product, onConfirm }) => {
  const branches = Array.isArray(product?.branch_stock) ? product.branch_stock : [];

  // Keep local state of requested quantities per branch
  const initialSelections = useMemo(
    () => branches.map(b => ({ id_branch: b.id_branch, requestedQty: 0 })),
    [branches]
  );
  const [selections, setSelections] = useState(initialSelections);

  // Reset selections when product or open changes
  React.useEffect(() => {
    setSelections(
      branches.map(b => ({ id_branch: b.id_branch, requestedQty: 0 }))
    );
  }, [product, open]);


  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: '2rem', fontWeight: 'bold'}}>Branch Stock</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ fontSize: '1.0rem', mb: 2, fontWeight: 'bold' }}>
          {product?.desc_prod_full} (Code: {product?.id_prod})
        </Typography>

        {branches.length === 0 ? (
          <Typography color="text.secondary">No branch stock data available.</Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{fontSize: '1.0rem',fontWeight: 'bold'}}>Branch</TableCell>
                <TableCell sx={{ fontSize: '1.0rem',fontWeight: 'bold'}}>Phone</TableCell>
                <TableCell sx={{ fontSize: '1.0rem',fontWeight: 'bold'}} align="right">On Hand</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {branches.map(b => {
//                const selection = selections.find(s => s.id_branch === b.id_branch);

                return (
                  <TableRow key={b.branchCode}>
                    <TableCell sx={{ fontSize: '1.0rem', fontWeight: 'bold'}}>{b.branchName}</TableCell>
                    <TableCell sx={{ fontSize: '1.0rem', fontWeight: 'bold'}}>{b.branchPhone}</TableCell>
                    <TableCell sx={{ fontSize: '1.0rem', fontWeight: 'bold'}} align="right">{b.qty}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BranchStockDialog;